// "Do not share" — the browser half of the ads opt-out.
//
// One localStorage key, set from the switch on /privacy, plus the browser's own
// Global Privacy Control signal (navigator.globalPrivacyControl; the server also
// reads the `Sec-GPC` header). Either one stops a signup being told to X. Read
// at the moment the first touch is posted (lib/utm.ts sendFirstTouch), which is
// the only moment anything about a person reaches X.

const KEY = "innernet.ads_opt_out";

/** True when the browser sends Global Privacy Control. */
export function gpcOn(): boolean {
  if (typeof navigator === "undefined") return false;
  return (navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl === true;
}

/** The switch on /privacy, as this browser last left it. */
export function doNotShareSet(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function setDoNotShare(on: boolean): void {
  if (typeof window === "undefined") return;
  try {
    if (on) localStorage.setItem(KEY, "1");
    else localStorage.removeItem(KEY);
  } catch {
    /* storage disabled — GPC remains the way to say it */
  }
}

/** Whether this browser has asked, either way, that nothing be shared with ad platforms. */
export function adsOptedOut(): boolean {
  return gpcOn() || doNotShareSet();
}
